
/* ================= CONTACT ================= */

import api from "../../../api/api";

/** Contact List */
export const getContactList = (
  page: number,
  params: any = {}
) => {
  return api.get("/crm/v1/contacts/", {
    params: {
      page,
      ...params,
    },
  });
};


/** Create Contact */
export const createContact = (payload: any) => {
  return api.post("/crm/v1/contacts/", payload);
};

export const getContactById = (id: number) => {
  return api.get(`/crm/v1/contacts/${id}/`);
};

/** Update Contact */
export const updateContact = (id: number, payload: any) => {
  return api.put(`/crm/v1/contacts/${id}/`, payload);
};


/** Delete Contact */
export const deleteContact = (id: number) => {
  return api.delete(`/crm/v1/contact-directory/${id}/`);
};




/* ================= MASTER DATA ================= */

/** Inquiry Source (REUSED FROM INQUIRY) */
export const getInquirySourceList = () => {
  return api.get("/crm/v1/source/");
};

/** Client Segment (REUSED FROM HR) */
export const getClientSegmentList = (params?: {
  vertical_id?: number;
}) => {
  return api.get("/hr/v1/client-segment-master/", {
    params,
  });
};

/** Vertical List */
export const getVerticalList = () => {
   return api.get("/hr/v1/verticals/");
};

/** Responsible Users (for vertical assignment) */
export const getResponsibleUsers = (params: {
  vertical_id: number;
}) => {
  return api.get("/crm/v1/responsible-user/", {
    params,
  });
};

/** ✅ Convert to Followup */
export const convertToFollowup = (id: number) => {
  if (!id) throw new Error("Contact ID is required");

  return api.post(`/crm/v1/contacts/${id}/convert-followup/`);
};

